export const contextKey = 'contextTerminus';
export const getWrapper = (nextAction) => (fnArgs, executionContext) =>
	nextAction(fnArgs, executionContext);
getWrapper.contextKey = contextKey;
